// TODO: move all of these inside corresponding components (SC-64122)
export const ANCHOR_STYLE = {
  'default': 'anchor--default',
  'primary': 'anchor--primary',
  'secondary': 'anchor--secondary',
  'dark-blue': 'anchor--dark-blue',
} as const

export const REQUEST_APP_PROPS = {
  buttonText: 'Request app',
  buttonType: 'secondary',
  to: 'https://forms.gle/ctxBQyLygS8FtaYu7',
  target: '_blank',
} as const
